import parsePhoneNumber from "libphonenumber-js";

const validPhoneNumber = (str) => {
  const phoneNumber = parsePhoneNumber(`+${str.replace(/^\+/, "")}`);
  return (phoneNumber && phoneNumber.isValid()) || false;
};

export default validPhoneNumber;
